import { setWebHooks } from './actionTypes';

export const handleWebHooksClick = checked => dispatch => {
    localStorage.bypassWebHooks = checked;
    dispatch(setWebHooks(checked));
};



// WEBPACK FOOTER //
// ./src/features/shared/webHooks/actions.js